import React from 'react';
import cx from 'classnames';
import Icon from '../Icon/Icon';
import './CheckSelect.scss';
import { InfoButton } from '../index';
const CheckSelectNotRedux = ({
  onChange,
  inline,
  value,
  checked,
  label,
  size,
  labelPosition,
  variant,
}) => {
  const handleOnChange = () => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={`check-select  check-select--${variant || 'primary'}`}>
      <label className={inline ? 'inline' : ''}>
        <input type="checkbox" checked={checked} readOnly={true} />

        <span className="label__text" onClick={handleOnChange}>
          {labelPosition === 'left' && <span className={' label-left'}>{label}</span>}
          <span className={cx('label label__check', { small: size === 'small' })}>
            <Icon name={'check'} />
          </span>
          {(!labelPosition || labelPosition === 'right') && (
            <span className={' label-right'}>{label}</span>
          )}
        </span>
      </label>
    </div>
  );
};

const getNewValue = (currentValue, checkedValue, uncheckedValue) => {
  if (currentValue === checkedValue) {
    return uncheckedValue;
  } else {
    return checkedValue;
  }
};
const CheckSelect = ({
  input,
  label,
  definition,
  meta,
  checkedValue,
  uncheckedValue,
  handleOnChange,
  disabled,
  labelPosition,
  variant,
  additionLabelClass,
}) => {
  const onChange = () => {
    if (disabled) {
      return;
    }
    // if values are not boolean toggle them, otherwise return opposite boolean value
    const newValue = uncheckedValue
      ? getNewValue(input.value, checkedValue, uncheckedValue)
      : !input.value;
    if (handleOnChange) {
      handleOnChange(newValue);
    }
    input.onChange(newValue);
  };

  return (
    <div className={`check-select  check-select--${variant || 'primary'}`}>
      <label className={label ? '' : 'no-margin'}>
        <input
          //defaultChecked={input.value === checkedValue}
          checked={input.value === checkedValue}
          value={input.value === checkedValue}
          type="checkbox"
          disabled={disabled}
        />
        <span className={`label__text ${additionLabelClass}`} onClick={onChange}>
          <InfoButton content={definition} title={label} />
          {labelPosition === 'left' && <span className={'label-left'}>{label}</span>}
          <span className={`label  label__check ${label ? '' : 'no-margin'}`}>
            <Icon name={'check'} />
          </span>
          {(!labelPosition || labelPosition === 'right') && (
            <span className={'label-right'}>{label}</span>
          )}
        </span>
      </label>
      {meta.touched && meta.error ? (
        <div className="input-error"> {meta.error} </div>
      ) : null}
    </div>
  );
};
export { CheckSelect, CheckSelectNotRedux };
